import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/material/bottom-sheet';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import * as i2 from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import * as i3 from '@digipay/layout';
let NgxSmartDialogService = /*#__PURE__*/(() => {
  class NgxSmartDialogService {
    constructor(bottomSheet, dialog, smartDialogConfig, layoutService) {
      this.bottomSheet = bottomSheet;
      this.dialog = dialog;
      this.smartDialogConfig = smartDialogConfig;
      this.layoutService = layoutService;
      this.isBottomSheet = false;
      this.config = smartDialogConfig;
      this.layoutService.register([`(max-width: ${this.config.dialogBottomSheetBreakPoint})`]).subscribe(result => {
        this.isBottomSheet = result;
      });
    }
    open(component, data, options) {
      this.data = data;
      const reference = this.isBottomSheet ? this.bottomSheet : this.dialog;
      const referenceWidth = this.calculateWidth(options);
      const referenceHeight = this.calculateHeight(options);
      const referenceMaxWidth = this.calculateMaxWidth(options);
      const referenceMaxHeight = this.calculateMaxHeight(options);
      this.last = reference.open(component, {
        data,
        width: referenceWidth,
        height: referenceHeight,
        maxWidth: referenceMaxWidth,
        maxHeight: referenceMaxHeight,
        panelClass: options && options.fullHeightBottomSheet ? 'full-height' : null
      });
      let sub;
      if (this.last instanceof MatBottomSheetRef) {
        sub = this.last.afterDismissed();
      }
      if (this.last instanceof MatDialogRef) {
        sub = this.last.afterClosed();
      }
      return new Promise(resolve => {
        sub.subscribe(result => {
          resolve(result);
        });
      });
    }
    calculateWidth(options) {
      if (this.isBottomSheet) {
        return '100%';
      }
      if (options && options.width) {
        return options.width;
      }
      if (this.config.defaultWidth) {
        return this.config.defaultWidth;
      }
      return '';
    }
    calculateHeight(options) {
      if (this.isBottomSheet) {
        if (options && options.fullHeightBottomSheet) {
          return '100%';
        }
      }
      if (options && options.height) {
        return options.height;
      }
      if (this.config.defaultHeight) {
        return this.config.defaultHeight;
      }
      return '';
    }
    calculateMaxWidth(options) {
      if (options && options.maxWidth) {
        return options.maxWidth;
      }
      if (this.config.defaultMaxWidth) {
        return this.config.defaultMaxWidth;
      }
      return '';
    }
    calculateMaxHeight(options) {
      if (options && options.maxHeight) {
        return options.maxHeight;
      }
      if (this.config.defaultMaxHeight) {
        return this.config.defaultMaxHeight;
      }
      return '';
    }
    close(result) {
      if (this.last.close && typeof this.last.close === 'function') {
        return this.last.close(result);
      }
      if (this.last.dismiss && typeof this.last.dismiss === 'function') {
        this.last.dismiss(result);
      }
    }
    static {
      this.ɵfac = function NgxSmartDialogService_Factory(t) {
        return new (t || NgxSmartDialogService)(i0.ɵɵinject(i1.MatBottomSheet), i0.ɵɵinject(i2.MatDialog), i0.ɵɵinject('smartDialogConfig'), i0.ɵɵinject(i3.LayoutService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxSmartDialogService,
        factory: NgxSmartDialogService.ɵfac
      });
    }
  }
  return NgxSmartDialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxSmartDialogModule = /*#__PURE__*/(() => {
  class NgxSmartDialogModule {
    static withConfig(smartDialogConfig) {
      return {
        ngModule: NgxSmartDialogModule,
        providers: [{
          provide: 'smartDialogConfig',
          useValue: smartDialogConfig
        }]
      };
    }
    static {
      this.ɵfac = function NgxSmartDialogModule_Factory(t) {
        return new (t || NgxSmartDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxSmartDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [NgxSmartDialogService],
        imports: [CommonModule]
      });
    }
  }
  return NgxSmartDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-smart-dialog
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSmartDialogModule, NgxSmartDialogService };
